import {FC, useState, useEffect, Fragment} from 'react'
import Button from 'react-bootstrap/Button'
import {PageTitle} from '../../../../../_metronic/layout/core'
import Form from 'react-bootstrap/Form'
import {Col, Modal, Row, Spinner} from 'react-bootstrap'
import Pagination from 'react-bootstrap/Pagination'
import {useNavigate} from 'react-router-dom'
import CompanyServices from '../../../../../services/company'
import useServices from '../../../../../utils/hooks/useServices'
import useDebounce from '../../../../../utils/hooks/useDebounce'
import 'react-quill/dist/quill.snow.css'
import MasterServices from '../../../../../services/master'
import FormGenerator from 'utils/helpers/FormGenerator'
import HTMLRenderer from 'react-html-renderer'

const JobsPage: FC = () => {
  let navigate = useNavigate()
  const [pagination, setPagination] = useState({
    per_page: 10,
    page: 1,
    total_page: 1,
    total_page_arr: [1, 2, 3, 4, 5],
    total_row: 10,
  })
  const [showFilter, setShowFilter] = useState(false)
  const [query, setQuery] = useState<any>({
    q: '',
    sort_order: 'desc',
    sort_field: 'companies_id',
    is_company: true,
  })

  const [filter, setFilter] = useState<any>({
    city_id: [],
    industry_id: [],
    ownership_id: [],
  })

  const [loading, setLoading] = useState<boolean>()

  const [submit, setSubmit] = useState(false)
  const [jobs, loadingJobs, makeJobsEmpty, refreshJobs] = useServices(
    CompanyServices.getCompanyHash,
    {
      ...query,
      page: pagination.page,
      per_page: pagination.per_page,
      status: [1],
      city_id: filter.city_id,
      industry_id: filter.industry_id,
      ownership_id: filter.ownership_id,
    },
    []
  )

  const [formValue, setFormValue] = useState<any>({})
  const [inputs, setInputs] = useState([
    {
      name: 'city_id',
      label: 'Lokasi',
      type: 'select2',
      validation: {},
      col: 12,
      options: [],
      additional: '',
      getItemValue: 'cities_name',
      getItemValueId: 'cities_id',
    },
    {
      name: 'industry_id',
      label: 'Industri',
      type: 'select2',
      validation: {},
      col: 12,
      options: [],
      additional: '',
      getItemValue: 'industries_name',
      getItemValueId: 'industries_id',
    },
    {
      name: 'ownership_id',
      label: 'Kepemilikan',
      type: 'select2',
      validation: {},
      col: 12,
      options: [],
      additional: '',
      getItemValue: 'company_ownerships_name',
      getItemValueId: 'company_ownerships_id',
    },
  ])

  useEffect(() => {
    fetchIndustry()
    fetchCity()
    fetchOwnership()
  }, [])

  useEffect(() => {
    refreshJobs()
    generateTotalPage(pagination.total_page)
    setShowFilter(false)
  }, [filter])

  useEffect(() => {
    refreshJobs()
    generateTotalPage(pagination.total_page)
  }, [pagination.per_page, pagination.page])

  useDebounce(refreshJobs, 250, [query])

  const generateTotalPage = (totalPage: number) => {
    let total = 0
    let newTotal: any = []

    for (total = 0; total < totalPage; total++) {
      newTotal.push(total + 1)
    }

    return newTotal
  }

  const onChangePerPage = (per_page: number, to_page = 1) => {
    setPagination({
      ...pagination,
      per_page: per_page,
      page: to_page || 1,
    })
  }

  const toggleFilter = () => setShowFilter(!showFilter)

  const fetchCity = async (q = '') => {
    setLoading(true)
    await MasterServices.getCity({...{is_active: 1}, q})
      .then((response) => {
        const {data} = response.data
        inputs[0].options = data
        setInputs(inputs)
        setLoading(false)
      })
      .catch((err) => {
      })
  }

  const fetchIndustry = async (q = '') => {
    setLoading(true)
    await MasterServices.getIndustry({...{is_active: 1}, q})
      .then((response) => {
        const {data} = response.data
        inputs[1].options = data
        setInputs(inputs)
        setLoading(false)
      })
      .catch((err) => {
      })
  }

  const fetchOwnership = async (q = '') => {
    setLoading(true)
    await MasterServices.getCompanyOwnership({...{is_active: 1}, q})
      .then((response) => {
        const {data} = response.data
        inputs[2].options = data
        setInputs(inputs)
        setLoading(false)
      })
      .catch((err) => {
      })
  }

  const onChange = (e: any) => {
    setFormValue({
      ...formValue,
      [e.target.name]: e.target.value,
    })
  }

  const onKeyUp = (input: any, value: any, key: any) => {
    const name = input
    switch (name) {
      case 'city_id':
        fetchCity(value)
        break
      case 'industry_id':
        fetchIndustry(value)
        break
      case 'ownership_id':
        fetchOwnership(value)
        break
    }
  }

  const handleFilter = () => {
    setFilter({
      city_id: formValue?.city_id?.cities_id ? [formValue?.city_id?.cities_id] : [],
      industry_id: formValue?.industry_id?.industries_id
        ? [formValue?.industry_id?.industries_id]
        : [],
      ownership_id: formValue?.ownership_id?.company_ownerships_id
        ? [formValue?.ownership_id?.company_ownerships_id]
        : [],
    })
  }

  const handleReset = () => {
    setFormValue({})
  }

  return (
    <>
      <Modal show={showFilter} onHide={submit ? () => null : toggleFilter} size='lg'>
        <Modal.Header closeButton>
          <Modal.Title> Filter</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>{FormGenerator(inputs, formValue, onChange, onKeyUp)}</Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => handleReset()}>
            Reset
          </Button>
          <Button onClick={() => handleFilter()}>Terapkan</Button>
        </Modal.Footer>
      </Modal>
      <div className='row'>
        <div className='col-md-12'>
          <div className='card-custom mb-8'>
            <Row>
              <Col md={{span: 4}}>
                <Form.Control
                  placeholder='Cari...'
                  name='q'
                  onChange={(e) => setQuery({...query, q: e.target.value})}
                />
              </Col>
              <Col md={{span: 2, offset: 4}}>
                <Button type='button' onClick={toggleFilter} className='form-control'>
                  Filter
                </Button>
              </Col>
              <Col md={{span: 2}}>
                <Form.Select
                  aria-label='Default select example'
                  className='mr-8'
                  onChange={(e) => {
                    setQuery({...query, sort_order: e.target.value})
                  }}
                >
                  <option value='desc'>Terbaru</option>
                  <option value='asc'>Terlama</option>
                </Form.Select>
              </Col>
            </Row>
          </div>

          <div style={{marginLeft: '40%'}}>
            {loadingJobs && (
              <Spinner animation='border' role='status' style={{height: '100px', width: '100px'}} />
            )}
            {jobs.data?.data?.length === 0 && !loadingJobs && <h5>Tidak ada Data</h5>}
          </div>
          <Row>
            {jobs?.data?.data?.map((item: any, key: number) => (
              <Col md={6} key={key}>
                <div
                  className='card-custom mb-8'
                  style={{cursor: 'pointer'}}
                  onClick={() =>
                    navigate(`/crafted/pages/profile/company-overview?company=${item.companies_id}`)
                  }
                >
                  <Row>
                    <Col md={3}>
                      {item?.logo_url_full ? (
                        <img src={item?.logo_url_full} style={{width: '75px', height: '75px'}} />
                      ) : (
                        <div
                          style={{
                            height: '75px',
                            width: '75px',
                            background: '#D9D9D9',
                            borderRadius: 10,
                          }}
                        />
                      )}
                    </Col>
                    <Col md={9}>
                      <h4 style={{color: '#FF6C06'}}>{item.companies_name}</h4>
                      <span>{item.city?.cities_name}</span>
                      <br />
                      <br />
                      <p style={{height: '150px'}}>
                        <HTMLRenderer
                          html={`${item.companies_overview.substring(0, 250)} ${
                            item.companies_overview?.length > 250 ? '...' : ''
                          }`}
                        />
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <hr />
                      <img src={require('../../../../../assets/icons/job-field.png')} />
                      <span style={{textTransform: 'capitalize'}}>
                        {'   '}
                        {item?.industry?.industries_name}
                      </span>
                    </Col>
                  </Row>
                </div>
              </Col>
            ))}
          </Row>
          {jobs?.data?.data?.length > 0 && (
            <Fragment>
              <div>
                <span>
                  Menampilkan {jobs?.data?.from} - {jobs?.data?.to} dari {jobs?.data?.total}
                </span>
              </div>
              <div style={{float: 'right'}}>
                <Pagination>
                  {generateTotalPage(jobs?.data?.last_page)?.map((item: any) => {
                    return (
                      <Pagination.Item
                        key={item}
                        active={item === pagination.page}
                        onClick={() => {
                          makeJobsEmpty()
                          onChangePerPage(pagination.per_page, item)
                        }}
                      >
                        {item}
                      </Pagination.Item>
                    )
                  })}
                </Pagination>
              </div>
            </Fragment>
          )}
        </div>
      </div>
    </>
  )
}

const CompanySearch: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Dashboard',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        Cari Perusahaan
      </PageTitle>
      <JobsPage />
    </>
  )
}

export default CompanySearch
